@if (dataList && columns) {
  @if (!dataList.error) {
    <cm-ui-table
      [columns]="columns"
      [rows]="dataList.rows"
      [rowsTotal]="dataList.total"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [actions]="actions"
      [loading]="isLoading"
      [headerButtons]="tableMenuButtons"
      [selectionType]="selectionType"
      [searchVisible]="searchVisible"
      [showMobileColumnPicker]="true"
      [enableDirectoryNavigation]="enableDirectoryNavigation"
      [currentDirectoryPath]="currentDirectoryPath"
      (tableButtonClick)="onTableAction($event)"
      (paginateChange)="onPaginationChange($event)"
      (actionClicked)="onActionClicked($event)"
      (sortChange)="onSortChange($event)"
      (search)="onSearchValueChange($event)"
      (columnsChange)="onColumnsChange($event)"
      (selectionChange)="onMultipleActionClicked($event)"
      (directoryNavigate)="onDirectoryNavigate($event)"
    ></cm-ui-table>
  }
  @if (dataList.error) {
    <p class="error-msg" translate>commonError</p>
  }
}
